import React from 'react';
import './Info.css';

function Info() {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '50vh',
      gap: '2rem',
      padding: '0 1rem',
      textAlign: 'center'
    }}>
      <p style={{
        fontSize: '1rem',
        maxWidth: '600px',
        lineHeight: '1.6'
      }}>
        Rock n roll, punkabilly, blues, country… Zoë writes American songs. All she needs is a car and a guitar and you can catch her anywhere in the country.
      </p>
      <p style={{
        fontSize: '1rem',
        marginTop: '-1rem',
        fontWeight: 'bold'
      }}>
        Founder of Carsick Loser Records
      </p>
      <p style={{
        fontSize: '1rem',
        marginTop: '-1rem'
      }}>
        <span style={{ color: '#000' }}>email: </span>
        <span style={{ color: '#8fce00' }}>zoepeteford@gmail.com</span>
      </p>
      <div className="info-stage">
        <img
          src="/images/tattoo_city_19.jpeg"
          alt="Tattoo City"
          className="info-album-image"
        />
        <a
          href="https://zoepeteford.bandcamp.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="info-side-label info-side-label--left"
        >
          NEW ALBUM
        </a>
        <a
          href="https://zoepeteford.bandcamp.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="info-side-label info-side-label--right"
        >
          OUT ON BANDCAMP 9/22/26
        </a>
      </div>
    </div>
  );
}

export default Info;
